"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailToolbarButton = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const tooltip_1 = require("../../components/tooltip/tooltip");
const detail_types_1 = require("./detail-types");
const detail_styles_1 = require("./detail-styles");
function DetailToolbarButton({ label, tooltip, disabled, onClick, href, type = detail_types_1.DetailToolbarButtonType.NORMAL, startIcon, endIcon, ...restProps }) {
    const classes = detail_styles_1.useStyles();
    const buttonProps = { ...restProps };
    if (type === detail_types_1.DetailToolbarButtonType.PRIMARY) {
        buttonProps.color = 'primary';
        buttonProps.variant = 'contained';
        buttonProps.classes = { root: classes.toolbarMainButton };
    }
    else if (type === detail_types_1.DetailToolbarButtonType.SECONDARY) {
        buttonProps.color = 'secondary';
        buttonProps.variant = 'contained';
        buttonProps.classes = { root: classes.toolbarMainButton };
    }
    return (react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip, placement: "top-start" },
        react_1.default.createElement(Button_1.default, Object.assign({ onClick: onClick, href: href, disabled: disabled, classes: { root: classes.toolbarButton } }, buttonProps, { variant: "outlined", startIcon: startIcon, endIcon: endIcon }), label)));
}
exports.DetailToolbarButton = DetailToolbarButton;
//# sourceMappingURL=detail-toolbar-button.js.map